import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28791aa6")

_pushScopeId("data-v-28791aa6")
const _hoisted_1 = {
  key: 1,
  class: "avatar body-4"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: 
      `uk-flex uk-flex-middle uk-flex-center uk-button button--thoth ${_ctx.getButtonClass()} ${
        _ctx.disabled ? 'disabled' : ''
      }`
    ,
    style: _ctx.buttonStyle,
    disabled: _ctx.disabled,
    type: "button"
  }, [
    (_ctx.iconBefore)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          src: _ctx.iconBefore,
          alt: "icon__before"
        }, null, 8, ["src"]))
      : _createCommentVNode("", true),
    (_ctx.email)
      ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.email), 1))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.text), 1)
  ], 14, ["disabled"]))
})